import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CreditCard } from 'lucide-react';
import type { FilterState } from '../GlobalFilters';

interface FeesMarginTabProps {
  clientId: string;
  filters: FilterState;
}

export function FeesMarginTab({ clientId, filters }: FeesMarginTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <CreditCard className="mr-2 h-5 w-5" />
          Frais & Marges
        </CardTitle>
        <CardDescription>Analyse des frais Amazon et rentabilité</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">Données des frais en cours de chargement...</p>
      </CardContent>
    </Card>
  );
}